import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { HiX, HiOutlineTicket } from 'react-icons/hi';
import { Link } from 'react-router-dom';

const PromoModal = () => {
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        // Retraso de 10 segundos para no interrumpir el primer impacto del Hero
        const timer = setTimeout(() => {
            const hasSeenPromo = sessionStorage.getItem('hasSeenPromo');
            if (!hasSeenPromo) {
                setIsOpen(true);
            }
        }, 10000); // 10 Segundos exactos

        return () => clearTimeout(timer);
    }, []);

    const closePromo = () => {
        setIsOpen(false);
        sessionStorage.setItem('hasSeenPromo', 'true');
    };

    return (
        <AnimatePresence>
            {isOpen && (
                <div className="fixed inset-0 z-[500] flex items-center justify-center p-4 bg-[#1C1C1C]/90 backdrop-blur-xl">

                    {/* Overlay para cerrar al hacer clic fuera */}
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        onClick={closePromo}
                        className="absolute inset-0 cursor-pointer"
                    />

                    <motion.div
                        initial={{ scale: 0.9, opacity: 0, y: 60 }}
                        animate={{ scale: 1, opacity: 1, y: 0 }}
                        exit={{ scale: 0.9, opacity: 0, y: 60 }}
                        transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
                        className="relative bg-[#1C1C1C] text-white w-full max-w-lg rounded-[3rem] overflow-hidden border border-white/10 shadow-[0_25px_60px_rgba(0,0,0,0.8)] p-8 md:p-14 text-center"
                    >
                        {/* Botón Cerrar */}
                        <button
                            onClick={closePromo}
                            className="absolute top-8 right-8 text-white/20 hover:text-[#F26B1D] transition-colors"
                        >
                            <HiX size={28} />
                        </button>

                        {/* Icono con animación de pulso */}
                        <motion.div
                            animate={{
                                scale: [1, 1.05, 1],
                                rotate: [12, 15, 12]
                            }}
                            transition={{ duration: 4, repeat: Infinity }}
                            className="inline-flex items-center justify-center w-24 h-24 bg-[#F26B1D] rounded-[2rem] mb-10 shadow-2xl shadow-[#F26B1D]/30"
                        >
                            <HiOutlineTicket className="text-5xl text-white" />
                        </motion.div>

                        {/* Contenido de Texto */}
                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.4 }}
                        >
                            <h3 className="text-4xl md:text-5xl font-black mb-6 leading-[0.9] tracking-tighter">
                                OFERTA DE <br />
                                <span className="text-[#F26B1D]">LANZAMIENTO</span>
                            </h3>

                            <p className="text-gray-400 text-lg md:text-xl mb-8 font-medium">
                                Modelos de planos Base <br className="hidden md:block" />
                                listos para tu proyecto desde:
                            </p>

                            {/* SECCIÓN DE PRECIOS DOBLE */}
                            <div className="flex flex-col items-center gap-3 mb-12">
                                <div className="flex items-baseline gap-4">
                                    <span className="text-white font-black text-6xl tracking-tighter">
                                        S/ 30
                                    </span>

                                    {/* Badge de Dólares al costado */}
                                    <div className="flex items-center bg-white/5 border border-white/10 px-4 py-2 rounded-2xl">
                                        <span className="text-[10px] font-black text-[#F26B1D] mr-2">USD</span>
                                        <span className="text-xl font-black text-white/90">$8</span>
                                    </div>
                                </div>
                               { /*<span className="text-[10px] text-white/30 font-bold uppercase tracking-[0.2em]">
                                    Precio por m² según proyecto
                                </span>*/}
                                <span className="text-[10px] text-white/30 font-bold uppercase tracking-[0.2em]">
                                    Adquierelo y modificalo a tu medida 
                                </span>
                            </div>
                        </motion.div>

                        {/* Botón de Acción */}
                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.6 }}
                        >
                            <Link
                                to="/planos"
                                onClick={closePromo}
                                className="inline-block w-full py-6 bg-[#F26B1D] text-white font-black rounded-2xl hover:bg-[#ff7a2e] transition-all duration-300 active:scale-95 shadow-xl shadow-[#F26B1D]/20 uppercase tracking-[0.2em] text-xs"
                            >
                                EXPLORAR CATÁLOGO
                            </Link>

                            <p className="mt-8 text-[9px] text-white/10 uppercase tracking-[0.4em] font-black italic">
                                * Aplica para diseños estándar seleccionados
                            </p>
                        </motion.div>
                    </motion.div>
                </div>
            )}
        </AnimatePresence>
    );
};

export default PromoModal;